import React from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import { colors } from '../../../../lib/colors';
import HomecomingLogo from './HomecomingLogo';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  patientInfo: {
    flexDirection: 'column',
  },
  patientName: {
    fontSize: 12,
    color: colors.neutral[150],
    fontWeight: 500,
  },
  participantId: {
    fontSize: 10,
    color: colors.neutral[125],
    marginTop: 2,
  },
  completedDate: {
    fontSize: 10,
    color: colors.neutral[125],
    marginTop: 4,
  },
  logoContainer: {
    marginBottom: 16,
  },
  wordmarkImage: {
    width: 100.5,
    height: 16,
    objectFit: 'contain',
  },
});

interface HeaderProps {
  patientName: string | undefined;
  completedAtDateFormatted: string;
  wordmarkLogoUrl?: string | null;
  participantId?: string | null;
  /** e.g. "Completed by [Provider Name]" or "Completed by Client" for practitioner-only forms */
  completedByLabel?: string | null;
}

const Header: React.FC<HeaderProps> = ({
  patientName,
  completedAtDateFormatted,
  wordmarkLogoUrl,
  participantId,
  completedByLabel,
}) => (
  <View style={styles.container}>
    <View style={styles.patientInfo}>
      {patientName && <Text style={styles.patientName}>{patientName}</Text>}
      {participantId && (
        <Text style={styles.participantId}>
          Participant ID: {participantId}
        </Text>
      )}
      <Text style={styles.completedDate}>{completedAtDateFormatted}</Text>
      {completedByLabel && (
        <Text style={[styles.completedDate, { marginTop: 2 }]}>
          {completedByLabel}
        </Text>
      )}
    </View>
    <View style={styles.logoContainer}>
      {wordmarkLogoUrl ? (
        <Image src={wordmarkLogoUrl} style={styles.wordmarkImage} />
      ) : (
        <HomecomingLogo />
      )}
    </View>
  </View>
);

export default Header;
